export default "__VITE_ASSET__Cdcu1kyD__"